export default __webpack_public_path__ + "static/media/incomingVideoImage.0a2f0f1c.png";